import { render, staticRenderFns } from "./aiService.vue?vue&type=template&id=3e357e48&scoped=true&"
import script from "./aiService.vue?vue&type=script&lang=js&"
export * from "./aiService.vue?vue&type=script&lang=js&"
import style0 from "./aiService.vue?vue&type=style&index=0&id=3e357e48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e357e48",
  null
  
)

export default component.exports